import { runInAction, makeAutoObservable } from 'mobx';
import { Permission, PermissionProps } from '@watcherr/resources';

import { State } from '~/store/types';

class PermissionStore {
  rootStore: State;
  permissionEntry?: PermissionProps;
  constructor(rootStore: State) {
    makeAutoObservable(this);

    this.rootStore = rootStore;
  }
  get entryList() {
    return this.entries.map((entry) => entry.permission.name);
  }
  get entries() {
    if (!this.permissionEntry) {
      return [];
    }
    return this.permissionEntry.entries;
  }
  loadPermissions() {
    Permission.getOwnPermissions().then((permissionEntries) => {
      runInAction(() => {
        this.permissionEntry = permissionEntries[0];
      });
    });
  }
}

export default PermissionStore;
